import {DxPopupComponent} from 'devextreme-angular/ui/popup';
import {Component, Input, ViewChild} from '@angular/core';
import {AjaxService} from 'AjaxService';

@Component({
    selector: 'app-handuch-popup',
    templateUrl: './handuch-popup.component.html',
    styleUrls: ['./handuch-popup.component.css'],
    standalone: false
})
export class HanduchPopupComponent {
  @ViewChild('popupHandbuch', {static: false}) popupHandbuch: DxPopupComponent;
  @ViewChild('popupShow', {static: false}) popupShow: DxPopupComponent;

  @Input() type: string = 'extern';

  init: boolean = false;
  filteredDatas: any[] = [];
  searchText: string = '';
  _all: any[] = [];
  popupVisible: boolean = false;
  pdfSrc = '/api/Handbuch/Download?id=';
  pdfname = '';

  get all(): any[] {
    return JSON.parse(JSON.stringify(this._all));
  }

  constructor(private ajaxService: AjaxService) {
    this.onClickClose = this.onClickClose.bind(this);
    this.onHiddenPopupHandbuch = this.onHiddenPopupHandbuch.bind(this);
    this.onShowClick = this.onShowClick.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onHiddenPopupShow = this.onHiddenPopupShow.bind(this);
    this.hidePopupShow = this.hidePopupShow.bind(this);
    this.downloadPopupShow = this.downloadPopupShow.bind(this);
  }

  open() {
    this.popupHandbuch.instance.show();
    this.load();
  }

  onClickClose(e) {
    this.popupHandbuch.instance.hide();
  }

  onHiddenPopupHandbuch(e) {
    this.init = false;
    this.searchText = '';
  }

  load() {
    this.ajaxService.post<any[]>('api/Handbuch/GetAllByType', {type: this.type}).subscribe({
      next: (response) => {
        for (let index = 0; index < response.length; index++) {
          response[index].name = response[index].name.replace(/(?:\r\n|\r|\n)/g, '<br>');
          response[index].beschreibung = response[index].beschreibung.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        this._all = response;
        this.filter();
        this.init = true;
      },
      error: (err) => {
        throw err;
      },
    });
  }

  valueChanged(e) {
    if (e.value !== undefined && e.value !== null) {
      this.filter();
    }
  }

  filter() {
    if (this.searchText !== undefined && this.searchText !== null && this.searchText.length > 0) {
      const results = this.all.filter((x) => x.name.toLowerCase().includes(this.searchText.toLowerCase()) || x.beschreibung.toLowerCase().includes(this.searchText.toLowerCase()));
      for (let index = 0; index < results.length; index++) {
        results[index].isOpen = true;
        results[index].name = this.replace(results[index].name);
        results[index].beschreibung = this.replace(results[index].beschreibung);
      }

      this.filteredDatas = results;
    } else {
      this.filteredDatas = this.all;
    }
  }

  replace(text) {
    if (text.toLowerCase().includes(this.searchText.toLowerCase())) {
      let start_index = text.toLowerCase().indexOf(this.searchText.toLowerCase());
      const spanStart = '<span class="handbuch-popup-item-found">';
      const spanEnd = '</span>';
      const searchTextLower = this.searchText.toLowerCase();

      while (start_index !== -1) {
        if (start_index !== -1) {
          const end_index = start_index + this.searchText.length;
          text = this.insertAt(start_index, text, spanStart);
          text = this.insertAt(end_index + spanStart.length, text, spanEnd);
          start_index = text.toLowerCase().indexOf(searchTextLower, end_index + spanStart.length + spanEnd.length);
        }
      }
    }

    return text;
  }

  insertAt(index, text, replacement) {
    return text.substring(0, index) + replacement + text.substring(index);
  }

  onCollapseClick(e: any, data: any) {
    if (data.isOpen === true) {
      data.isOpen = false;
    } else {
      data.isOpen = true;
    }
  }

  onShowClick(e: any, data: any) {
    e.preventDefault();
    e.stopPropagation();
    this.pdfSrc = '/api/Handbuch/Download?id=' + data.id;
    this.pdfname = data.orgFileName;
    this.popupVisible = true;
  }

  onDownloadClick(e: any, data: any) {
    e.preventDefault();
    e.stopPropagation();
    this.ajaxService.download('/api/Handbuch/Download?id=' + data.id, data.orgFileName);
  }

  //---

  onHiddenPopupShow(event) {
    this.popupVisible = false;
  }

  hidePopupShow() {
    this.popupVisible = false;
  }

  downloadPopupShow() {
    this.ajaxService.download(this.pdfSrc, this.pdfname);
  }
}
